import SingleLineTextInput from "./SingleLineTextInput";

export default SingleLineTextInput;
